import styled from 'styled-components'
import { theme } from '@/client/components'
const { color, font, space, breakpoint } = theme

export const Filter = styled.div`
  margin-bottom: ${space.xl3};

  & .gallery-scroll {
    padding: 0 1rem;
  }

  @media (min-width: ${breakpoint.lg}) {
    text-align: center;

    button {
      margin-bottom: ${space.md};
    }
  }
`

export const ImageInfos = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: ${space.lg};
  background-color: ${color.grayscale.black};
  opacity: 0;
  transition: opacity 0.3s ease;
  overflow-y: auto;

  @media (min-width: ${breakpoint.lg}) {
    top: 20px;
    left: calc(100% + 20px);
    width: calc(100% - 20px);
    height: auto;
    max-height: auto;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow-y: visible;
    pointer-events: none;
  }
`

export const ImageInfosRectangle = styled.div`
  display: none;

  @media (min-width: ${breakpoint.lg}) {
    position: absolute;
    display: block;
    z-index: 0;
    top: 0;
    left: -20px;
    width: 20px;
    height: calc(100% - 20px);
    background-color: ${color.grayscale.black};

    &::before,
    &::after {
      content: '';
      position: absolute;
      display: block;
      left: 0;
      width: 0;
      height: 0;
      border-style: solid;
    }

    &::before {
      top: -20px;
      border-width: 20px 0 0 20px;
      border-color: transparent transparent transparent ${color.grayscale.black};
    }

    &::after {
      content: '';
      bottom: -20px;
      border-width: 0 20px 20px 0;
      border-color: transparent ${color.grayscale.black} transparent transparent;
    }
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
  will-change: transform, opacity;
  transform: translateZ(0);
  content-visibility: auto;
  contain-intrinsic-size: 500px;
  &:hover {
    z-index: 10;
    transform: translateY(-2px);

    ${ImageInfos} {
      opacity: 1;
    }
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }

  @media (min-width: ${breakpoint.lg}) {
    filter: grayscale(0%);
  }
`

export const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
`

export const Text = styled.p`
  padding: 0 ${space.md};
  color: ${color.text.normal};
  font-family: ${font.family.heading};
  font-size: ${font.size.root};
  font-weight: ${font.weight.bold};
  line-height: ${font.lineHeight.md};
  text-align: center;
  height: 3.5rem;
`
